import { Box, Table, Tbody, Th, Thead, Tr } from '@chakra-ui/react';
import _ from 'lodash';
import React from 'react';

import { utils as commonUtils } from '@finley-technologies/common';

import { WipConfig } from '../../types';
import { CreditAgreement } from 'packages/creditAgreements/ui/CreditAgreementFullArtifact/common';
import { PropertyView } from 'packages/creditAgreements/ui/CreditAgreementFullArtifact/property/PropertyView';

const { isNil } = _;

type PropertyTableProps = {
  propertyPairs: [
    string,
    (
      | CreditAgreement.DomainEntity.Property
      | CreditAgreement.DomainEntity.PropertyContainer
      | null
    ),
  ][];
  basePropertyKey: string;
  wipConfig?: WipConfig;
  isPropertyContainerContent?: boolean;
  columnWidth?: number;
  headerNameMapping?: {
    // optional param to change table header names
    [key in
      | keyof CreditAgreement.DomainEntity.Property
      | keyof CreditAgreement.DomainEntity.PropertyContainer]?: string;
  };
};
export const PropertyTable = ({
  propertyPairs,
  basePropertyKey,
  wipConfig,
  isPropertyContainerContent,
  columnWidth,
  headerNameMapping,
}: PropertyTableProps) => {
  if (!propertyPairs) return null;

  const properties = _.compact(
    _.map(propertyPairs, (propertyPair) => {
      if (!isNil(propertyPair[1])) {
        return propertyPair;
      }
      return undefined;
    }),
  );

  const headers: (
    | keyof CreditAgreement.DomainEntity.Property
    | keyof CreditAgreement.DomainEntity.PropertyContainer
  )[] = wipConfig
    ? ['name', 'value', 'section', 'description', '_note_', '_isWrittenIn_']
    : ['name', 'value', 'section', 'description'];

  return (
    <Box display="flex" mb="20px" width="100%">
      <Table borderWidth="1px">
        <Thead>
          <Tr>
            {Array.from(headers).map((header) => {
              const headerName =
                (headerNameMapping && headerNameMapping[header]) ?? header;
              return (
                <Th key={headerName}>{commonUtils.toTitleCase(headerName)}</Th>
              );
            })}
            {wipConfig && <Th key="action">Action</Th>}
          </Tr>
        </Thead>
        <Tbody>
          {_.map(properties, ([propertyKey, property], index) => {
            if (!property) return null;

            return (
              <PropertyView
                headers={Array.from(headers)}
                key={`${basePropertyKey}.${propertyKey}.${index}`}
                basePropertyKey={basePropertyKey}
                propertyKey={propertyKey}
                property={property}
                wipConfig={wipConfig}
                idx={isPropertyContainerContent ? index : undefined}
                columnWidth={columnWidth}
              />
            );
          })}
        </Tbody>
      </Table>
    </Box>
  );
};
